import { React, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import { useHistory } from "react-router";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import _ from "lodash";
import clsx from "clsx";
import { Alert, Container } from "react-bootstrap";
import SetWithdrawTable from "./components/SetWithdrawTable";
import * as userSelectors from "../../selectors/user";
import ConfirmationSetOffModal from "../ESetOff/SetOff/modal/ConfirmationSetOffModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faWarning } from "@fortawesome/free-solid-svg-icons";
import * as withdrawActions from "../../action/withdraw";
import CashWithdrawalNotes from "./components/CashWithdrawalNotes";
function EWithdraw() {
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const [partAmt, setPartAmt] = useState(null);

  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const selectedAccount = _.find(accountSelections, "is_selected");
  const currenciesSelections = userSelectors.getUserAccountSelectionsCurrencies(selectedAccount);
  const selectedCurrency = _.find(currenciesSelections, "is_selected");
  const selectedCurrencyText = _.get(selectedCurrency, ["text"], null);
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const search = history?.location?.search;


  const { loading, data, isFetched } = useQuery({
    queryKey: ["withdraw-data"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/withdraw${search}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });

  const withdrawData = _.get(data, ["data"], []);
  const attributes = _.get(data, ["attributes"], null);
  const esp_bank_account = _.get(attributes, ["esp", "esp_bank_account"], "");
  // const handleSubmit = useCallback(async (postData, totalWithdraw) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axiosInstance.post("clientarea/withdraw", {
  //       withdraw_amount: totalWithdraw,
  //       items: postData,
  //     });
  //     if (response.code === 200) {
  //       history.push(PAGE.STATEMENT_SUMMARY);
  //     }
  //   } catch (e) {
  //     console.log("ee" + e);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }, []);

  const getTotalAmount = (partAmtData) => {
    const debit = _.map(partAmtData, (item, index) => {
      return _.floor(item.total, 2);
    });
    return _.isNaN(_.sum(debit)) ? 0 : _.sum(debit);
  };

  const totalValue = useMemo(() => getTotalAmount(partAmt), [partAmt]);
  const handleSubmit = (postData) => {
    // const result = _.map(partAmt, (item, index) => {
    //   if (item.total !== 0) {
    //     return {
    //       data: { ...withdrawData[index] },
    //       subTotal: item.total,
    //     };
    //   }
    // });
    if (!_.isEmpty(postData)) {
      dispatch(
          withdrawActions.setWithdrawData({
            items: postData,
            currency: selectedCurrency,
            attributes: attributes,
            clientCode: selectedAccount,
            bankAccount: esp_bank_account,
            totalAmount: totalValue
          }),
      );
      history.push({
        pathname: `/dashboard/cash-withdrawal`
      });
    }
  };

  const getDebitAmount = (partAmtData) => {
    const debit = _.map(partAmtData, (item, index) => {
      if (item.negative) {
        return _.floor(item.total, 2);
      }

      return 0;
    });
    return _.isNaN(_.sum(debit)) ? 0 : _.sum(debit);
  };

  const debitValue = useMemo(() => getDebitAmount(partAmt), [partAmt]);
  const isEspEnabled = _.get(attributes, ["is_esp_enabled"], false);
  const isOperateWithdraw = _.get(attributes, ["is_operate"], false);
  const isOperateWithdrawCutOff = _.get(attributes, ["cutoff_time"], false);
  const isForeignCurrency = selectedCurrency.key !== 'MYR';
  const esp_bank_branch = _.get(attributes, ["esp", "esp_bank_branch"], "");
  const esp_bank_name = _.get(attributes, ["esp", "esp_bank_name"], "");

  return (
      <Container fluid>
        <div className={clsx("custom-setoff-table-title-container")}>
          {
            isForeignCurrency ? (
                <Alert key="info" variant="secondary" sx={{borderRadius: "5px"}}>
                  <div style={{color: "#2c2c2c"}}>
                        <span className={"text-bold-600"}>
                          <FontAwesomeIcon
                              icon={faCircleExclamation}
                              color="#2c2c2c"
                              size="xl"
                              style={{marginRight: 10}}
                          ></FontAwesomeIcon>
                          Our e-service platform does not allow foreign currency withdrawal, please refer to your dealer representative.
                        </span>
                  </div>
                </Alert>
            ) : (
                isEspEnabled ? (
                    <Alert key="info" variant="secondary" sx={{borderRadius: "5px"}}>
                      <div style={{color: "#2c2c2c"}}>
                        <span className={"text-bold-600"}>
                          <FontAwesomeIcon
                              icon={faCircleExclamation}
                              color="#2c2c2c"
                              size="xl"
                              style={{marginRight: 10}}
                          ></FontAwesomeIcon>
                          {`Withdrawal amount will be credited to`}{" "}
                          <b>{esp_bank_name}</b>
                          {` / `}
                          <b>{esp_bank_account}</b>
                        </span>
                      </div>
                    </Alert>
                ) : (
                    isFetched ? (
                        <Alert key="danger" variant="danger">
                          <div className={"d-flex flex-column flex-md-row align-items-center"}>
                            <div>
                              <FontAwesomeIcon
                                  icon={faWarning}
                                  color="#fff"
                                  size="xl"
                                  style={{marginRight: 10}}
                              ></FontAwesomeIcon>
                              <b style={{fontSize: "16px"}}><u style={{textDecorationStyle: "double"}}>Attention </u> :</b>
                            </div>
                            <div className={"text-bold-600  ms-0 ms-md-3"}>
                              You will not be able to proceed with e-withdrawal as you have not applied for our Electronic
                              Share Payment (ESP) facility.<br/>
                              Please contact your Dealer's Representative to apply for ESP to enable e-withdrawal.
                            </div>
                          </div>
                        </Alert>
                    ) : false
                )
            )
          }
          {!isOperateWithdraw ? (
              <Alert key="info" variant="secondary" sx={{borderRadius: "5px"}}>
                <div style={{color: "#2c2c2c"}}>
                <span className={"text-bold-600"}>
                  <FontAwesomeIcon
                      icon={faCircleExclamation}
                      color="#2c2c2c"
                      size="xl"
                      style={{marginRight: 10}}
                  ></FontAwesomeIcon>
                  {`Our facility temporary was not available now.`}
                </span>
                </div>
              </Alert>
          ) : (
              false
          )}
        </div>
        <div className={"primary-border-table-border"}>
          <div className={clsx("custom-card-label-container")}>
            <div className={clsx("d-flex")}>
              <div>
                <h2>{selectedCurrencyText}</h2>
              </div>
              <div className={clsx("d-flex justify-content-center flex-fill")}>
                <h2>Withdrawal</h2>
              </div>
            </div>
          </div>
          <div className={clsx("custom-table-info-container padding-12px")}>
            <SetWithdrawTable
                data={_.get(data, ["data"], [])}
                partAmt={partAmt}
                setPartAmt={setPartAmt}
                debitValue={debitValue}
                selectedCurrency={selectedCurrency}
                isEspEnabled={isEspEnabled}
                isFetched={isFetched}
                isOperateWithdraw={isOperateWithdraw}
                isOperateWithdrawCutOff={isOperateWithdrawCutOff}
            ></SetWithdrawTable>

            <div className="d-flex justify-content-center py-3">
              <button
                  onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                  }}
                  className={clsx("btn custom-button-back")}
                  type="submit"
              >
                Back
              </button>
              <button
                  className={clsx("btn custom-button-primary", {})}
                  type="submit"
                  disabled={!isEspEnabled || !isOperateWithdraw || isForeignCurrency}
                  style={{backgroundColor: "#9D7905"}}
                  onClick={() => {
                    setShow(true);
                    setType(constants.WITHDRAWAL_TYPE);
                  }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <CashWithdrawalNotes></CashWithdrawalNotes>

        <ConfirmationSetOffModal
            show={show}
            data={data}
            partAmt={partAmt}
            handleSubmit={handleSubmit}
            handleClose={() => setShow(false)}
            loading={isLoading}
            type={type}
            selectedCurrency={selectedCurrency}
        ></ConfirmationSetOffModal>
      </Container>
  );
}

export default EWithdraw;
